export default "__VITE_ASSET__DcsYvIqr__"